import styled from 'styled-components';

import { getThemeColor, getThemePath, media } from '@utils/styled';

import Typography from '@common/components/Typography';
import Button from '@common/components/Button';

export const OrderList = styled.ul`
  display: flex;
  flex-wrap: wrap;
  margin: 0;
  ${({ theme }) => theme.getFluidSpacing('margin-top', 'scale', 2)}
  padding: 0;
`;

export const OrderItem = styled.li`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  border: 1px solid ${getThemeColor('bluegrey.80')};
  border-radius: ${getThemePath(['borderRadiuses', 'normal.2'])}rem;
  padding: 2rem;

  ${media.from560up`
    flex-wrap: nowrap;
    ${({ theme }) => theme.getFluidAttribute('gap', 1.2, 2)};
  `}

  & + & {
    margin-top: 1rem;
  }
`;

export const OrderItemValue = styled(Typography).attrs({
  variant: 'paragraph2',
})`
  flex: 1;
  margin: 0;
  margin-right: auto;
`;

export const OrderItemDedicationButton = styled(Button).attrs({
  type: 'button',
})`
  order: 1;
  width: 100%;
  margin-top: 1.5rem;
  white-space: nowrap;

  ${media.from560up`
    order: unset;
    width: auto;
    margin-top: 0;
  `}
`;

export const OrderItemRemoveButtonWrapper = styled.div`
  flex-shrink: 0;
`;
